import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import WsAvatar from '../../../../features/teams/components/WsAvatar';
import PersonAvatar from '../../../../images/Avatar/Person.svg';
import { stripHtmlUsingRegex } from '../../util/JobCampaignEmailHelper';

interface EmailPreviewCardProps {
  userName: string;
  subject: string;
  bodyPreview: string;
  emailSentTime: string;
  userImageUrl?: string;
}

export const EmailPreviewCard: React.FC<EmailPreviewCardProps> = ({
  userName,
  subject,
  bodyPreview,
  emailSentTime,
  userImageUrl = PersonAvatar,
}) => (
  <Grid display="flex" flexDirection="row" columnGap={1} alignItems="flex-start" p={1}>
    <Grid item xs={1} display="flex" justifyContent="flex-end">
      <WsAvatar src={userImageUrl} />
    </Grid>
    <Grid item xs={10}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <WsTypography bold>{`To: ${userName}`}</WsTypography>
        <WsTypography variant={WsTypoVariants.BODY2} opacity={true}>
          {emailSentTime}
        </WsTypography>
      </Box>
      <Typography
        variant="body1"
        color="text.primary"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
        }}
      >
        {subject}
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
        }}
      >
        {stripHtmlUsingRegex(bodyPreview)}
      </Typography>
    </Grid>
  </Grid>
);
